<template>
  <div class="flex items-baseline">
    <div class="flex-1">
      <div
        class="bg-gray-100 p-3"
        :class="{
          rounded: !customize,
          'rounded-t': customize,
        }"
      >
        <div class="flex -mx-3 items-baseline">
          <div class="flex-1 px-4 py-2">
            <span class="block">{{ entity.name }}</span>
          </div>
          <div class="flex-none px-4">
            <BaseLinkButton v-if="selected && upgradable" green @click="customize = !customize">
              Αναβαθμιση
            </BaseLinkButton>
            <template v-if="entity.optional">
              <BaseLinkButton v-if="!selected" silver @click="add">
                Προσθηκη (+ {{ entity.price }} &euro;)
              </BaseLinkButton>

              <BaseLinkButton v-else silver @click="remove"> Αφαιρεση </BaseLinkButton>
            </template>
          </div>
        </div>
      </div>
      <div v-show="selected && customize" class="rounded-b bg-purple-200 p-8">
        <BaseLayoutSpaced>
          <template v-for="productServiceUpgrade in productServiceUpgrades">
            <slot :product-service-upgrade="productServiceUpgrade" />
          </template>
        </BaseLayoutSpaced>
      </div>
    </div>
    <div class="w-24 p-3 font-medium text-right">
      <span v-if="(entity.optional && selected) || (!entity.optional && entity.price > 0)">
        {{ entity.price }} &euro;
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductService',
  props: {
    entity: {
      type: Object,
      required: true,
    },
    selected: Boolean,
  },
  data: () => ({
    customize: false,
  }),
  computed: {
    ...mapState('entities', {
      productsById: (state) => state.products.byId,
      productServicesById: (state) => state.productServices.byId,
    }),
    service() {
      return this.productsById[this.entity.serviceUuid];
    },
    productServiceUpgrades() {
      return this.entity.upgrades.map((id) => this.productServicesById[id]);
    },
    upgradable() {
      return this.productServiceUpgrades.length > 0;
    },
  },
  methods: {
    add() {
      this.$emit('add', { ...this.entity });
    },
    remove() {
      this.$emit('remove', { ...this.entity });
    },
  },
};
</script>
